import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtilsService, QueryParamsModel} from '../_base/crud';
import {map} from 'rxjs/operators';
import {SpaceModel} from '../models/space.model';
import {environment} from '../../../environments/environment';
import { OKResponse } from '../_base/crud/models/query-models/query-results.model';
import { ItemsResponse } from '../_base/crud/models/query-models/items-response.model';

const API_SPACES_URL = `${environment.pathToAPI}/api/v1/spaces`;

@Injectable()
export class SpacesService {
    constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
    }

    createSpace(space: SpaceModel): Observable<SpaceModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<SpaceModel>(API_SPACES_URL, space, {headers: httpHeaders});
    }

    getAllSpaces(): Observable<SpaceModel[]> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get<SpaceModel[]>(API_SPACES_URL, {headers: httpHeaders}).pipe(map<any, SpaceModel[]>((value) => {
            return value.response;
        }));
    }

    getSpaceById(spaceId: number): Observable<SpaceModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.get<SpaceModel>(API_SPACES_URL + `/${spaceId}`, {headers: httpHeaders});
    }

    findSpaces(queryParams: QueryParamsModel<SpaceModel>): Observable<ItemsResponse<SpaceModel>> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<ItemsResponse<SpaceModel>>(
            API_SPACES_URL + '/find',
            queryParams,
            {headers: httpHeaders}
        );
    }

    updateSpace(space: SpaceModel): Observable<SpaceModel> {
        const httpHeader = this.httpUtils.getHTTPHeaders();
        return this.http.put<SpaceModel>(API_SPACES_URL + `/${space.id}`, space, {headers: httpHeader});
    }

    deleteSpace(spaceId: number): Observable<OKResponse> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const url = `${API_SPACES_URL}/${spaceId}`;
        return this.http.delete<OKResponse>(url, {headers: httpHeaders});
    }
}
